import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { NavigationService } from '../services/navigation.service';
import { LanguageService } from './../services/language.service';

@Injectable()
export class LanguageGuard  {
  constructor(
    private languageService: LanguageService,
    private router: Router,
    private location: Location,
    private navigationService: NavigationService,
    ) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const lang = next.params.lang as string;
    if (this.languageService.isLanguage(lang)) {
      return this.languageService.setLanguage(lang);
    } else if (!this.languageService.isLanguage(lang)) {
      this.router.navigate(
        [this.languageService.getDefaultLanguage()],
        next.queryParams ? { queryParams: next.queryParams } : undefined,
      );
      return true;
    } else {
      this.languageService.getDefaultLanguage();
      this.navigationService.navigateToError();
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd),
          take(1),
        )
        .subscribe(() => this.location.replaceState(state.url));
    }
    return true;
  }
}
